import { StandardProps } from "@/components/componentMap";
import styles from "./EnergyLabelAndSaving.module.scss";
import { EnergyLabel } from "@/components/EnergyLabel/EnergyLabel.tsx";
import { EnergySaving } from "@/components/EnergySaving/EnergySaving.tsx";

export function EnergyLabelAndSaving({
  flags,
  product,
}: Pick<StandardProps, "product" | "flags">) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.energyLabelWrapper}>
        <EnergyLabel product={product} flags={flags} />
      </div>
      <EnergySaving product={product} />
    </div>
  );
}
